import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/app/src/layouts/empty.vue").then(m => m.default || m)),
  "master-detail": defineAsyncComponent(() => import("/app/src/layouts/masterDetail.vue").then(m => m.default || m))
}